import React, { Component } from "react";
import { Form, Row, Button as BootstrapButton, Col } from 'react-bootstrap';
import { Button, Paper, Box, Typography } from "@mui/material";
import { PersonAdd, Info } from "@mui/icons-material";

import CookieManager from "../managers/CookieManager";
import LocalStorageManager from "../managers/LocalStorageManager";
import Events from '../service/Events';

import LocationReader from "../managers/LocationReader";
import ClientAPI from "../service/ClientAPI";
import PageDescription from "../components/PageDescription";

class Register extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: LocationReader.ReadParameter("id", props.location.search)
        }
    }

    onSubmit = (ev) => {
        ev.preventDefault();

        const _inputs = ev.target,
            _email = _inputs.email.value,
            _password = _inputs.password.value,
            _rpassword = _inputs.rpassword.value,
            _save = _inputs.save.checked,
            _firstName = _inputs.firstName.value,
            _lastName = _inputs.lastName.value;

        if (!_password || !_rpassword || _password !== _rpassword) {
            Events.onResult.emit("error", "Passwörter stimmen nicht überein!");
            return;
        }

        var _websitePort = process.env.REACT_APP_WEBSITE_PORT;
        const _homepage = process.env.REACT_APP_DOMAIN
            ? `${process.env.REACT_APP_DOMAIN}${(_websitePort ? `:${_websitePort}` : "")}`
            : window.location.origin;

        ClientAPI.Register({
            token: this.state.token, _email, _password, _rpassword, _firstName, _lastName
        })
            .then((_res) => {
                CookieManager.Save("auth", _res.token);
                LocalStorageManager.Save("admin", _res.isAdmin);

                if (_save) {
                    LocalStorageManager.SaveMultiple([
                        { key: "isSaved", value: _save },
                        { key: "password", value: _password },
                        { key: "email", value: _email }
                    ]);
                }

                window.location.replace(_homepage);
            })
            .catch(console.error);
    }

    render() {
        return (
            <div style={{ minHeight: "90vh", width: window.innerWidth < 600 ? "95%" : "80%", margin: "auto", paddingBottom: window.innerWidth < 600 ? "40px" : "60px" }}>
                <Typography 
                    variant="h3" 
                    sx={{ 
                        textAlign: "center", 
                        marginTop: { xs: "20px", sm: "35px" }, 
                        marginBottom: { xs: "20px", sm: "30px" },
                        fontSize: { xs: "1.75rem", sm: "2.2rem" },
                        fontWeight: 700,
                        color: "#2e7d32"
                    }}
                >
                    Registrierung
                </Typography>

                {/* Info Box */}
                <Paper
                    elevation={3}
                    sx={{
                        borderRadius: { xs: '12px', sm: '16px' },
                        mb: { xs: 3, sm: 4 },
                        overflow: 'hidden',
                        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)"
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                            p: { xs: 1.5, sm: 2 },
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 1, sm: 1.5 }
                        }}
                    >
                        <Info sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                            Wichtige Informationen
                        </Typography>
                    </Box>
                    <Box sx={{ p: { xs: 2, sm: 3 } }}>
                        <PageDescription greetings={true} />
                    </Box>
                </Paper>

                {/* Registration Form */}
                <Paper
                    elevation={3}
                    sx={{
                        maxWidth: "700px",
                        margin: "auto",
                        borderRadius: { xs: '12px', sm: '20px' },
                        overflow: 'hidden',
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)"
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                            p: { xs: 2, sm: 3 },
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 1.5, sm: 2 }
                        }}
                    >
                        <PersonAdd sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} />
                        <Typography variant="h5" sx={{ fontWeight: 600, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                            Account erstellen
                        </Typography>
                    </Box>

                    <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                        <Form className="registerForm" onSubmit={this.onSubmit} style={{
                            display: 'grid',
                            gridTemplateAreas: `
                                "email email"
                                "firstName lastName"
                                "password repeatPassword"
                                "save save"
                                "submit submit"
                            `,
                            gap: '20px'
                        }}>
                            <Form.Group style={{ gridArea: "email" }} controlId="formGridEmail">
                                <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                    E-Mail
                                </Form.Label>
                                <Form.Control 
                                    name="email" 
                                    type="email" 
                                    placeholder="E-Mail"
                                    style={{
                                        borderRadius: '10px',
                                        padding: '12px',
                                        border: '2px solid #e0e0e0',
                                        fontSize: '1rem'
                                    }}
                                />
                            </Form.Group>

                            <Form.Group style={{ gridArea: "firstName" }} as={Col} controlId="formGridFirstname">
                                <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                    Vorname
                                </Form.Label>
                                <Form.Control 
                                    name="firstName" 
                                    type="text" 
                                    placeholder="Vorname"
                                    style={{
                                        borderRadius: '10px',
                                        padding: '12px',
                                        border: '2px solid #e0e0e0',
                                        fontSize: '1rem'
                                    }}
                                />
                            </Form.Group>

                            <Form.Group style={{ gridArea: "lastName" }} as={Col} controlId="formGridLastName">
                                <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                    Nachname
                                </Form.Label>
                                <Form.Control 
                                    name="lastName" 
                                    type="text" 
                                    placeholder="Nachname"
                                    style={{
                                        borderRadius: '10px',
                                        padding: '12px',
                                        border: '2px solid #e0e0e0',
                                        fontSize: '1rem'
                                    }}
                                />
                            </Form.Group>

                            <Form.Group style={{ gridArea: "password" }} as={Col} controlId="formGridPassword">
                                <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                    Passwort
                                </Form.Label>
                                <Form.Control 
                                    name="password" 
                                    type="password" 
                                    placeholder="Passwort"
                                    style={{
                                        borderRadius: '10px',
                                        padding: '12px',
                                        border: '2px solid #e0e0e0',
                                        fontSize: '1rem'
                                    }}
                                />
                            </Form.Group>

                            <Form.Group style={{ gridArea: "repeatPassword" }} as={Col} controlId="formGridRepeatPassword">
                                <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                    Passwort wiederholen
                                </Form.Label>
                                <Form.Control 
                                    name="rpassword" 
                                    type="password" 
                                    placeholder="Passwort wiederholen"
                                    style={{
                                        borderRadius: '10px',
                                        padding: '12px',
                                        border: '2px solid #e0e0e0',
                                        fontSize: '1rem'
                                    }}
                                />
                            </Form.Group>

                            <Form.Group style={{ gridArea: "save" }} className="mb-3" id="formGridCheckbox">
                                <Form.Check 
                                    name="save" 
                                    type="checkbox" 
                                    label="Anmeldedaten speichern"
                                    style={{ fontSize: '1rem', fontWeight: 500 }}
                                />
                            </Form.Group>

                                <Button 
                                style={{ gridArea: "submit" }} 
                                variant="contained" 
                                type="submit"
                                startIcon={<PersonAdd />}
                                fullWidth
                                sx={{
                                    bgcolor: '#2e7d32',
                                    color: 'white',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    fontSize: { xs: '0.95rem', sm: '1.1rem' },
                                    py: { xs: 1.3, sm: 1.5 },
                                    borderRadius: '10px',
                                    boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                                    '&:hover': {
                                        bgcolor: '#1b5e20',
                                        boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                        transform: 'translateY(-2px)'
                                    },
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                Registrieren
                            </Button>
                        </Form>
                    </Box>
                </Paper>
            </div>
        )
    }
}

export default Register;